import './international-navigation.js'
import './lazy-load.js'

import main from './main.js'
import home from './home.js'
import webstore from './webstore.js'

//
// ***** ID based imports *****
//
if(document.getElementById('agreement-accepted')) {
    import('./agreement-accept.js');
}
if(document.getElementById('careers-intake')) {
    import('./careers-form.js');
}
if(document.getElementById('cookie-consent')) {
    import('./cookie-consent.js');
}
if(document.getElementById('customer-page')) {
    import('./customers.js');
}
if(document.getElementById('uber-intake')) {
    import('./landing-form.js');
}
if(document.getElementById('marketplace-page')) {
    import('./marketplace.js');
}
if(document.getElementById('modular-form')) {
    import('./modular-form.js');
}
if(document.getElementById('product-tours-page')) {
    import('./product-tours.js');
}
if(document.getElementById('reduce-costs') ||
   document.getElementById('efficiency-hub')) {
    import('./efficiency.js');
}
if(document.getElementById('roi-calculator')) {
    import('./roi-calculator.js');
}
if(document.getElementById('staging-link-toggle-button')) {
    import('./staging-links.js');
}
if(document.getElementById('videos-page')) {
    import('./videos.js');
}
if(document.getElementById('guides-page')) {
    import('./guides-page.js');
}
if (document.getElementById("filter-dropdown-title")) {
  import("./filter-dropdown.js");
}
if(document.getElementById('cw-hero-wrap')) {
    import('./cw-sticky-hero.js')
}
if (document.getElementById("cw-image-grid")) {
  import("./cw-image-grid.js");
}
if (document.getElementById("cw-sticky-scroll")) {
  import("./cw-sticky-scroll.js");
}
if (document.getElementById("long-haul-main-slider")) {
  import("./long-haul-main-slider.js");
}
if (document.getElementById("header-content")) {
  import("./long-haul-hub-nav.js");
}
if (document.getElementById("platform-data-carousel")) {
  import("./platform-data-carousel.js");
}
if (document.getElementById("platform-accordion")) {
  import("./platform-accordion.js");
}
if (document.getElementById("platform-modal-slider")) {
  import("./platform-modal-slider.js");
}
if (document.getElementById("platform-scroll")) {
  import("./platform-scroll.js");
}
if (document.getElementById("audio-file")) {
  import("./custom-audio.js");
}
if(document.getElementById('referrals-hub')) {
    import('./referrals-hub.js');
}
if (document.getElementById("card-slider")) {
  import("./card-rotator.js");
}
if (document.getElementById("email-pref")) {
  import("./email-pref-alert.js");
}
if (document.getElementById("menu-page")) {
    import("./menu-page.js");
  }
if (document.getElementById("solutions-sticky-scroll")) {
    import("./solutions-sticky-scroll.js");
}
if (document.getElementById("index-case-study-carousel")) {
  import("./index-case-study-carousel.js");
}
if (document.getElementById("index-solution-carousel")) {
  import("./index-solution-carousel.js");
}
if (document.getElementById("static-header")) {
  import("./nav.js");
}
if (document.getElementById("vimeo-wrap")) {
  import("./vimeo-video.js");
}
//
// ***** Class based imports *****
//
if(document.getElementsByClassName('background-rotator').length) {
    import('./background-rotator.js');
}
if(document.getElementsByClassName('desktop-video').length ||
   document.getElementsByClassName('mobile-video').length) {
    import('./device-video.js');
}
if(document.getElementsByClassName('fleetprod-slider').length) {
    import('./fleet.js');
}
if(document.getElementsByClassName('footer-image-rotate').length ||
   document.getElementsByClassName('footer-rotate').length ||
   document.getElementsByClassName('next-up-image-rotate').length) {
    import('./simple-rotator.js');
}
if(document.getElementsByClassName('how-to').length) {
    import('./vertical-tabs.js');
}
if(document.getElementsByClassName('modular-image-rotator').length) {
    import('./image-rotator.js');
}
if(document.getElementsByClassName('scroll-tabs').length) {
    import('./scroll-tabs.js');
}
if(document.getElementsByClassName('simple-tabs-container').length) {
    import('./simple-tabs.js');
}
if(document.getElementsByClassName('vertical-rotator').length) {
    import('./vertical-rotator.js');
}
if (document.getElementsByClassName("careers-revamp").length) {
  import("./careers.js");
}
if(document.getElementById('reduce-costs') || document.getElementById('efficiency-hub')) {
    import('./efficiency.js');
}
if (document.getElementsByClassName("social-shares").length) {
  import("./social-share.js");
}
if (document.getElementsByClassName("solution-rotator").length) {
  import("./solution-rotator.js");
}
if (document.getElementsByClassName("dash-cam-carousel").length) {
  import("./dash-cam-carousel.js");
}
if (document.getElementsByClassName("long-haul-transition").length) {
  import("./long-haul-transitions.js");
}
if (document.getElementsByClassName("longhaul-chapter").length) {
  import("./long-haul-chapter-nav.js");
}
if (document.getElementsByClassName("modular-modal").length) {
  import("./modular-modal.js");
}
if (document.getElementsByClassName('solutions-blue-ring').length) {
    import('./solutions_parallax.js');
}